import ReactDOM from 'react-dom'
import { SpinLoading, Mask } from 'antd-mobile'
import styles from './index.scss'

let requestCount = 0
// 显示loading
export function showLoading() {
  if (requestCount === 0) {
    var dom = document.createElement('div')
    dom.setAttribute('id', 'loading')
    document.body.appendChild(dom)
    ReactDOM.render(<Loading />, dom)
  }
  requestCount++
}

// 隐藏loading
export function hideLoading() {
  requestCount--
  if (requestCount === 0) {
    document.body.removeChild(document.getElementById('loading') as any)
    if(document.body.classList) document.body.classList.remove('adm-overflow-hidden')
  }
}

export default function Loading() {
  return (
    <Mask opacity={0.5} color="white">
      <div className={styles.content}>
        <SpinLoading />
      </div>
    </Mask>
  )
}
